import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { get, post, put } from "../../../../../utils/api";
import contries from "../../../Roles and Permissions/Country.json";
import { textError } from "../../../../../utils/validationMessage";
import EmailField from "../../../../../Components/Masters/EmailField";
import PhoneInput from "../../../../../Components/Masters/PhoneInput";
import SelectField from "../../../../../Components/Masters/SelectField";
import PhoneInputField from "../../../../../Components/Masters/PhoneInputField";
import { validateNumber } from "../../../../../utils/validateFields";
import EditDialog from "../../../../../Components/Common/EditDialog";

function AddLogisticsVendorMaster(props) {
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [facilities, setFacilities] = useState(["Select Faciltiy"]); // Store list of facilities
  const [vendor, setVendors] = useState(["Select"]); // Store list of facilities
  const [verifybtn, setverifybtn] = useState({
    email: false,
    contactPersonMobile: false,
  });
  const [verify, setVerify] = useState({
    phone: false,
    mail: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    phone: false,
    email: true,
  });
  // Time state
  const [otp, setOTP] = useState({
    email: null,
    phone: null,
  });
  const [timerActive, setTimerActive] = useState({
    email: false,
    phone: false,
  });

  const [selectedEmail, setEmail] = useState("");
  const [timerPhone, setTimerPhone] = useState(120);
  const [time, setTime] = useState(120);
  const initialState = {
    logisticVendorLegalName: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    contactPersonName: "",
    phone: "",
    email: "",
    state: "",
    countryCode: "",
    pinCode: "",
  };
  const [errors, setErrors] = useState({});
  const [fromValue, setFromValue] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);

  useEffect(() => {
    fetchFacilities();

    // Only set form values if props.selectedLogestic is not null or undefined
    if (props.selectedLogestic) {
      const state = {
        logisticVendorLegalName:
          props.selectedLogestic.logisticVendorLegalName ?? "",
        addressLine1: props.selectedLogestic.addressLine1 ?? "Owned", // Default ownership type
        addressLine2: props.selectedLogestic.addressLine2 ?? "",
        country: props.selectedLogestic.country ?? "",
        contactPersonName: props.selectedLogestic.contactPersonName ?? "",
        phone: props.selectedLogestic.contactPersonMobile ?? "",
        countryCode: props.selectedLogestic.countryCode ?? "", // Default country code
        email: props.selectedLogestic.contactPersonEmail ?? "",
        state: props.selectedLogestic.state ?? "",
        pinCode: props.selectedLogestic.pinCode ?? "",
      };
      setFromValue(state);
      setFormData2(state);
      setAlreadyFacility(true);
      // setEmail(props.selectedLogestic.contactPersonEmail ?? "");
      if (props.selectedLogestic) {
        // setVerify({...verify,emailMsg:"",phoneMsg:""})
        setTaskAltIcons({ ...TaskAltIcons, phone: true, email: true });
      } else if (!props.selectedLogestic) {
        setTaskAltIcons({ ...TaskAltIcons, phone: false, email: false });
      }
    } else {
      handleExitAgree(); // Reset form when there's no selected facility
      setAlreadyFacility(false);
    }
  }, [props.selectedLogestic]);

  useEffect(() => {
    if (timerActive.email && time > 0) {
      const timer = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setTimerActive((prev) => ({ ...prev, email: false }));
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timerActive.email]);

  useEffect(() => {
    if (timerActive.phone && timerPhone > 0) {
      const timer = setInterval(() => {
        setTimerPhone((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setTimerActive((prev) => ({ ...prev, phone: false }));
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timerActive.phone]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFromValue({
      ...fromValue,
      [name]: value,
    });
    setErrors((prev) => ({ ...prev, [name]: "" })); // Reset error message for each field when it changes
  };

  const handleCountryChange = (event) => {
    setErrors({ ...errors, country: "" });
    const selectedCountryCode = event.target.value;
    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    ); // Find the selected country object

    if (selectedCountry) {
      setFromValue({
        ...fromValue,
        country: selectedCountry.name, // Set country name
        countryCode: selectedCountry.dial_code, // Set country code
        phone: "",
      });

      if (selectedCountry.dial_code && fromValue.phone !== "") {
        console.log(fromValue.phone, "fromValue.phone");
        setVerify({ ...verify, phone: true });
        setTaskAltIcons({ ...TaskAltIcons, phone: false, email: false });
        setErrors({ ...errors, [event.target.name]: "" });
      }
      if (errors.phone === "Please Select Country")
        setErrors({ ...errors, phone: "" });
    }
  };

  const fetchFacilities = async () => {
    try {
      const response = await get(
        `/master/getAllFacility?page=${1}&limit=${300}`
      );

      const result = await get(`/master/getAllVendors?page=${1}&limit=${300}`);

      setFacilities(response.data.data);
      setVendors(result.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const Save = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const dataToSubmit = { ...fromValue };
    try {
      const url = alreadyFacility
        ? `${props.url}/logistic/vendorMasterUpdate`
        : `${props.url}/logistic/vendorMaster`;
      const response = alreadyFacility
        ? await put(`${url}?id=${props.selectedLogestic?._id}`, dataToSubmit)
        : await post(url, dataToSubmit);

      props.setAddVendor(false);
      props.fetchLogesticVendor();
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      handleExitAgree();
    } catch (err) {
      const errorMessage = err?.response?.data?.message || "An error occurred";
      const errorKeys = err?.response?.data?.commonKeyMsg;
      console.log(errorMessage, errorKeys, "errorMessageerrorMessage");
      if (Array.isArray(errorKeys)) {
        const errorObj = {};
        errorKeys.forEach(({ key, msg }) => {
          errorObj[key] = msg;
        });

        setErrors((prevErrors) => ({
          ...prevErrors,
          ...errorObj,
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
        }));
      }
    }
  };
  const handleClose = () => {
    const excludedKeys = ["_id", "company"];

    const isFormDataUnchanged = Object.keys(fromValue).every((key) => {
      if (excludedKeys.includes(key)) {
        return true; // Skip comparison for excluded keys
      }
      return formData2[key] === fromValue[key];
    });

    console.log(isFormDataUnchanged, "isChanged", formData2, fromValue);

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const {
      logisticVendorLegalName,
      addressLine1,
      country,
      contactPersonName,
      phone,
      email,
      state,
      countryCode,
      pinCode,
    } = fromValue;

    if (!logisticVendorLegalName || logisticVendorLegalName.trim() === "") {
      newErrors.logisticVendorLegalName = textError;
    }

    if (!country || country === "Select Country") {
      newErrors.country = "Please select a country.";
    }

    // if (verifybtn.phone === true) {
    //  if (!countryCode || countryCode.trim() === "") {
    //   newErrors.phone = "Country code is required,  select the country.";

    // If phone is missing but countryCode is provided
    if (phone === "") {
      newErrors.phone = "Phone number is required .";
    } else if (!validateNumber(phone) || phone?.length < 7)
      newErrors.phone = "Please enter valid Phone Number";

    // else {
    //   newErrors.contactPersonMobile = "A valid phone number is required."; // Generic phone validation
    // }

    // if (verify.phone) {
    //   newErrors["phoneMsg"] = "OTP is required";
    //   // setVerify({ ...verify, phoneMsg: "OTP is required" });
    //   setVerify({ ...verify, phoneMsg: verify.phoneMsg || "OTP is required" });
    //   console.log(verifybtn, otp, "for testing the issue");
    // }

    if (!contactPersonName || contactPersonName.trim() === "") {
      newErrors.contactPersonName = "Person name is required.";
    }

    if (!addressLine1 || addressLine1.trim() === "") {
      newErrors.addressLine1 = "Address is required.";
    }
    if (!addressLine1 || addressLine1.trim() === "") {
      newErrors.addressLine1 = "Address is required.";
    }
    if (!state || state.trim() === "") {
      newErrors.state = textError;
    }
    if (!pinCode || String(pinCode).length > 10) {
      newErrors.pinCode = "Pincode must be 10 digits.";
    }
    // if (!licenseNumber || licenseNumber.trim() === "") {
    //   newErrors.licenseNumber = "License number is required.";
    // }

    // Email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email || !emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (verifybtn.email === true && email) {
      newErrors.email = "Email Verification required";
    } else if (verify.email) {
      newErrors["emailMsg"] = "Please enter the OTP";
      // setVerify({ ...verify, emailMsg: "Please enter the OTP" });
      setVerify({
        ...verify,
        phoneMsg: verify.phone && (verify.phoneMsg || "OTP is required"),
        // emailMsg: verify.emailMsg || "OTP is required",
      });
    }

    console.log(newErrors, pinCode, pinCode.length, "newErrors");
    // setErrors(newErrors);
    setErrors({ ...errors, ...newErrors });
    return Object.keys(newErrors).length === 0;
  };

  const element = {
    email: props.selectedFacility?.email || null,
    phone: props.selectedFacility?.phone || null,
  };

  const handleExitAgree = () => {
    setFromValue(
      props.selectedLogestic?._id === undefined
        ? initialState
        : {
            ...props.selectedLogestic,
            phone: props.selectedLogestic.contactPersonMobile ?? "",
            email: props.selectedLogestic.contactPersonEmail ?? "",
          }
    );
    setFormData2(
      props.selectedLogestic?._id === undefined
        ? initialState
        : {
            ...props.selectedLogestic,
            phone: props.selectedLogestic.contactPersonMobile ?? "",
            email: props.selectedLogestic.contactPersonEmail ?? "",
          }
    );
    setErrors({}); // Reset errors
    // setEmail(
    //   props.selectedLogestic?._id === undefined
    //     ? ""
    //     : props.selectedLogestic.contactPersonEmail
    // );
    setTaskAltIcons({
      email: false,
      phone: false,
    });
    setOTP({
      phone: null,
      email: null,
    });
    setVerify({
      phone: false,
      // mail: false,
    });
    setverifybtn({ email: false, phone: false });
    props.setAddVendor(false);
    setEditDialog(false);
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props.selectedLogestic?._id === undefined
            ? "Add Logistics Vendor"
            : "Edit Logistics Vendor"}
        </Typography>

        <SelectField
          title={"Country"}
          name={"country"}
          value={fromValue.country}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors["country"]}
          //   url={el.url}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Logistics Vendor Legal Name
        </Typography>
        <CustomTextField
          //   select
          variant="outlined"
          fullWidth
          name="logisticVendorLegalName"
          onChange={handleChange}
          value={fromValue.logisticVendorLegalName} // Use empty string as fallback if value is not in the list
          // onChange={handleDropdownChange}
          placeholder="Logistics Vendor Legal Name"
          error={!!errors.logisticVendorLegalName} // Show error styling if there's an error
          InputLabelProps={{
            style: {
              color: errors.logisticVendorLegalName ? "#D34040" : undefined,
            },
          }}
        ></CustomTextField>
        {errors.logisticVendorLegalName && (
          <Typography variant="body2" color="#D34040">
            {errors.logisticVendorLegalName}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Contact Person's Name
        </Typography>
        <CustomTextField
          variant="outlined"
          fullWidth
          name="contactPersonName"
          onChange={handleChange}
          value={fromValue.contactPersonName} // Use empty string as fallback if value is not in the list
          // onChange={handleDropdownChange}
          placeholder="Contact Person's Name"
          error={!!errors.contactPersonName} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.contactPersonName ? "#D34040" : undefined },
          }}
        ></CustomTextField>
        {errors.contactPersonName && (
          <Typography variant="body2" color="#D34040">
            {errors.contactPersonName}
          </Typography>
        )}
        <PhoneInputField
          title="Contact Person's Mobile Number"
          value={fromValue.phone || ""} // Correct field for the phone number
          fieldName="phone" // Corresponding field name in the formData
          placeholder="Enter Mobile Number"
          countryCode={fromValue.countryCode} // Country code as part of formData
          setFormData={setFromValue}
          formData={fromValue}
          showIcon={TaskAltIcons.phone === true}
          setErrors={setErrors}
          errors={errors?.phone}
          element={element}
          // verify={verify}
          // setVerify={setVerify}
          // verifybtn={verifybtn}
          // setverifybtn={setverifybtn}
          // TaskAltIcons={TaskAltIcons}
          // setTaskAltIcons={setTaskAltIcons}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Contact Person's Email Id
        </Typography>
        <TextField
          placeholder="Enter Email"
          size="small"
          fullWidth
          value={fromValue?.email || ""}
          onChange={(e) =>
            setFromValue((prev) => ({
              ...prev,
              email: e.target.value,
            }))
          }
          error={Boolean(errors?.email)}
          helperText={errors?.email || ""}
        />

        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          Address
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Address Line 1
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.addressLine1}
          onChange={handleChange}
          fullWidth
          name="addressLine1"
          placeholder=" Address Line 1"
          error={!!errors.addressLine1} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.addressLine1 ? "#D34040" : undefined },
          }}
        />
        {errors.addressLine1 && (
          <Typography variant="body2" color="#D34040">
            {errors.addressLine1}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Address Line 2
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.addressLine2}
          onChange={handleChange}
          fullWidth
          name="addressLine2"
          placeholder=" Address Line 2"
          error={!!errors.addressLine2} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.addressLine2 ? "#D34040" : undefined },
          }}
        />
        {/* drivering license */}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          State
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.state}
          onChange={handleChange}
          fullWidth
          name="state"
          placeholder="State"
          error={!!errors.state} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.state ? "#D34040" : undefined },
          }}
        />

        {errors.state && (
          <Typography variant="body2" color="#D34040">
            {errors.state}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
          Pin Code
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.pinCode}
          onChange={handleChange}
          fullWidth
          name="pinCode"
          placeholder="Pin Code"
          error={!!errors.pinCode} // Show error styling if there's an error
          InputProps={{
            inputProps: {
              maxLength: 10, // Restrict the input to 6 digits
              inputMode: "alpha-numeric", // Mobile-friendly input for numbers
              pattern: "[0-9]*", // Accept only numbers
            },
          }}
          InputLabelProps={{
            style: { color: errors.pinCode ? "#D34040" : undefined },
          }}
        />
        {errors.pinCode && (
          <Typography variant="body2" color="#D34040">
            {errors.pinCode}
          </Typography>
        )}

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            marginTop: "10%",
          }}
          onClick={Save}
        >
          Submit
        </Button>
        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addVendor}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddLogisticsVendorMaster;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "39px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
